module.exports = __webpack_public_path__ + "static/media/dollar_blue.50d984a3.svg";